import ConfirmCancelPaymentModal from './ConfirmCancelPaymentModal';

export default ConfirmCancelPaymentModal;
